import { render, staticRenderFns } from "./VesselsInfoComponent.vue?vue&type=template&id=829f059a&"
import script from "./VesselsInfoComponent.vue?vue&type=script&lang=js&"
export * from "./VesselsInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports